<template>
  <SeoPage page-key="softwareGestionaliBellinzona" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'SoftwareGestionaliBellinzonaPage'
})
</script>

